import { OptionType } from '@europrocurement/flexy-components';
import { AntennesUtilisateurApiObject } from '@europrocurement/l2d-domain';
import {
    GroupesJsonldGroupReadCollection,
    MarquesJsonldSocieteMarqueReadCollection,
    PolesJsonldDefPoleReadCollection,
    ServicesJsonldServiceReadCollection,
} from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';

type GetOptionsProps = {
    services: ServicesJsonldServiceReadCollection[];
    poles: PolesJsonldDefPoleReadCollection[];
    marques: MarquesJsonldSocieteMarqueReadCollection[];
    groupes: GroupesJsonldGroupReadCollection[];
    antennes: AntennesUtilisateurApiObject[];
};

/**
 * Get these collections and format them into OptionType[] for selects
 * @param service services collection from API
 * @param poles poles collection from API
 * @param marques marques collection from API
 * @param groupes groupes collection from API
 * @returns servicesOptions, polesOptions, marquesOptions, groupesOptions
 */
export const getSelectsOptions = ({
    services,
    poles,
    marques,
    groupes,
    antennes,
}: GetOptionsProps) => {
    const servicesOptions: Array<OptionType> = [];
    const polesOptions: Array<OptionType> = [];
    const marquesOptions: Array<OptionType> = [];
    const groupesOptions: Array<OptionType> = [];
    const antennesOptions: Array<OptionType> = [];

    if (services && services.length > 0) {
        services.map((service) =>
            servicesOptions.push({
                label: service.libelle as string,
                value: service.id,
            }),
        );
    }

    if (poles && poles.length > 0) {
        poles.map((pole) =>
            polesOptions.push({
                label: pole.libelle as string,
                value: pole.id,
            }),
        );
    }

    if (marques && marques.length > 0) {
        marques.map((marque) =>
            marquesOptions.push({
                label: marque.libelle as string,
                value: marque.idMarque,
            }),
        );
    }

    if (groupes && groupes.length > 0) {
        groupes.map((groupe) =>
            groupesOptions.push({
                label: `Groupe ${groupe.groupName}`,
                value: groupe.id,
            }),
        );
    }

    if (antennes && antennes.length > 0) {
        antennes
            .filter((antenne) => antenne.isDeleted === false)
            .map((antenne) =>
                antennesOptions.push({
                    label: antenne.libelle as string,
                    value: antenne.idAntenne as number,
                }),
            );
    }

    return { servicesOptions, polesOptions, marquesOptions, groupesOptions, antennesOptions };
};
